import React from "react";
import Modal from "react-modal";
import FileUpload from "./FileUpload";
import { useTaskContext } from "../context/TaskContext";
import Swal from "sweetalert2";

const AttachModal = ({
  isOpen,
  onRequestClose,
  selectedTask,
  customStyles2,
  onAttachmentsUpdated,
}) => {
  const { updateTask } = useTaskContext();

  if (!selectedTask) return null;

  // Al subir archivos: se actualiza el campo "attachments" de la tarea.
  const handleUpload = async (taskId, files) => {
    try {
      // attachments actuales
      const currentAttachments = selectedTask.attachments || [];

      // 1) Filtramos los archivos nuevos que ya existen en currentAttachments
      const duplicates = files.filter((file) =>
        currentAttachments.some((att) => att.name === file.name)
      );

      // 2) Avisamos si hay archivos duplicados
      if (duplicates.length > 0) {
        Swal.fire(
          "Algunos archivos ya existen",
          `Se omitió "${duplicates.map((d) => d.name).join(", ")}".`,
          "warning"
        );
      }

      // 3) Nos quedamos solo con los que NO están duplicados
      let nonDuplicates = files.filter(
        (file) => !currentAttachments.some((att) => att.name === file.name)
      );

      // 4) Si después de filtrar no queda nada por subir, salimos
      if (nonDuplicates.length === 0) {
        return;
      }

      // 5) Creamos el nuevo arreglo de attachments con lo existente + lo nuevo
      let newAttachments = [...currentAttachments, ...nonDuplicates];

      // 6) [Opcional Extra] Aseguramos que en newAttachments no haya repetidos
      //    (por si acaso se repiten dentro de "nonDuplicates" o cualquier otro caso).
      const uniqueAttachments = [];
      for (const fileObj of newAttachments) {
        const alreadyIn = uniqueAttachments.some(
          (att) => att.name === fileObj.name
        );
        if (!alreadyIn) {
          uniqueAttachments.push(fileObj);
        }
      }

      // 7) Guardamos attachments sin duplicados en Firestore
      await updateTask(taskId, { attachments: uniqueAttachments });
      onAttachmentsUpdated(uniqueAttachments);
      Swal.fire({
        title: "Archivo subido correctamente",
        icon: "success",
        scrollbarPadding: false,
      });
    } catch (error) {
      console.error("Error al actualizar archivos adjuntos:", error);
      Swal.fire({
        title: "Error",
        icon: "success",
        scrollbarPadding: false,
      });
    }
  };

  // Al eliminar un archivo: se actualiza el campo "attachments" removiendo el archivo eliminado
  const handleDeleteAttachment = async (taskId, fileId) => {
    try {
      const currentAttachments = selectedTask.attachments || [];
      const newAttachments = currentAttachments.filter(
        (att) => att.id !== fileId
      );
      await updateTask(taskId, { attachments: newAttachments });

      // Notifica al padre para actualizar el estado de la tarea
      onAttachmentsUpdated(newAttachments);
      Swal.fire({
        title: "Archivo eliminado",
        icon: "success",
        scrollbarPadding: false,
      });
    } catch (error) {
      console.error("Error al eliminar el archivo:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudo eliminar el archivo",
        icon: "success",
        scrollbarPadding: false,
      });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles2}
      contentLabel="Adjuntos"
    >
      <div className="modal-header">
        <button className="modal-close" onClick={onRequestClose}>
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
      <h2>Sube y Adjunta Archivos</h2>
      <FileUpload
        taskId={selectedTask.id}
        existingAttachments={selectedTask.attachments || []}
        onUpload={handleUpload}
        onDeleteAttachment={handleDeleteAttachment}
      />
    </Modal>
  );
};

export default AttachModal;
